"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var getScrollType_1 = __importDefault(require("./getScrollType"));
var mirrorScrollLeft = function (el, value) {
    var rtl = (0, helpers_1.isRTL)();
    if (!rtl)
        return value;
    var scrollType = (0, getScrollType_1.default)();
    if (scrollType === "negative")
        return -value;
    if (scrollType === "reverse")
        return value;
    return el.scrollWidth - el.clientWidth - value;
};
exports.default = mirrorScrollLeft;
